"use client"

import { useEffect } from "react"
import { Button } from "@/components/ui/button"
import { AlertCircle } from "lucide-react"
import posthog from "posthog-js"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Guarded on __loaded the same way app/global-error.tsx is: the provider
    // no-ops without NEXT_PUBLIC_POSTHOG_KEY, and an analytics call must never
    // be the reason an error screen fails to render.
    if (posthog.__loaded) {
      posthog.captureException(error, {
        error_boundary: "root",
        error_digest: error.digest || "unknown",
      })
    }
    console.error("[v0] Application error caught:", error.message)
  }, [error])

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-6 p-8 max-w-md">
        <AlertCircle className="w-16 h-16 text-destructive mx-auto" />
        <h1 className="text-2xl font-bold">Something went wrong</h1>
        <p className="text-muted-foreground">
          {process.env.NODE_ENV === "development"
            ? error.message
            : "We apologize for the inconvenience. Please try again."}
        </p>
        {error.digest && <p className="text-xs text-muted-foreground">Error ID: {error.digest}</p>}
        <div className="flex gap-4 justify-center">
          <Button onClick={reset}>Try again</Button>
          <Button variant="outline" onClick={() => (window.location.href = "/")}>
            Go home
          </Button>
        </div>
      </div>
    </div>
  )
}
